/* eslint-disable @typescript-eslint/ban-ts-comment */

import { Capacitor } from '@capacitor/core'
import { CypressRunning } from '../../util/noCypress'

/* eslint-disable @typescript-eslint/no-explicit-any */
export function loadAdobeLaunchScript() {
  // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
  const iOSScript = process.env.REACT_APP_ADOBE_SCRIPT_IOS!
  // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
  const normalScript = process.env.REACT_APP_ADOBE_SCRIPT!

  const scriptUrl = Capacitor.getPlatform() === 'ios' ? iOSScript : normalScript
  return new Promise<void>((resolve, reject) => {
    const script = document.createElement('script')
    script.src = scriptUrl
    script.async = true
    script.onload = () => resolve()
    script.onerror = (e) => reject(Error(String(e)))
    document.head.appendChild(script)
  })
}
declare global {
  interface Window {
    alloy: (command: string, options?: Record<string, any>) => Promise<any>
    _satellite?: {
      setVar: (key: string, value: string) => void
      getVar: (key: string) => string | undefined
      getVisitorId: () => any
    }

    Visitor?: {
      getMarketingCloudVisitorID: () => string | undefined
      getAnalyticsVisitorID: () => string | undefined
      isAllowed: () => boolean
      getInstance: () => any
    }

    adobeDataLayer?: Array<Record<string, any>>
  }
}

export function initializeAdobeECID(callback?: (mcid: string) => void) {
  if (CypressRunning) {
    return
  }
  if (!localStorage.getItem('mcid')) {
    return window
      .alloy('getIdentity')
      .then((result: any) => {
        console.log('Identity is here: ', result)
        const ecid = result?.identity?.ECID
        if (ecid) {
          console.log('ECID retrieved:', ecid)
          localStorage.setItem('mcid', ecid)
          if (window._satellite) {
            window._satellite.setVar('mcid', ecid)
          }
          callback?.(ecid)
        }
      })
      .catch((err: any) => {
        console.error('Error retrieving Adobe ECID:', err)
      })
  } else {
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    callback?.(localStorage.getItem('mcid')!)
  }
}
